import api from './api';

export interface EmailTemplate {
    _id?: string;
    id?: string; // Frontend uses id, backend uses _id
    title: string;
    description: string;
    slug: string;
    subject: string;
    content: string;
    fullHtml?: string;
    layoutTitle: string;
    reminders: number[];
    showCTA: boolean;
    buttonConfig?: {
        text: string;
        url: string;
        bgColor: string;
        textColor: string;
        borderRadius: string;
        width: string;
        height: string;
        alignment: string;
        vPosition: number;
        marginTop: string;
        marginBottom: string;
    };
    recipientMode: 'all' | 'specific';
    recipients: {
        _id?: string;
        id?: string;
        email?: string;
        email_address?: string;
        name?: string;
        first_name?: string;
        last_name?: string;
        type?: 'lead' | 'candidate' | 'manual';
    }[];
    type?: string;
    is_schedule_mail?: boolean;
    scheduledDates?: { dateTime: string }[];
    timezone?: string;
    is_simple_email?: boolean;
}

class EmailTemplateService {
    async getAllTemplates(params?: { type?: string }) {
        const response = await api.get<{ success: boolean; data: EmailTemplate[] }>('/email-templates', { params });
        return response.data.data;
    }

    async getTemplateById(id: string) {
        const response = await api.get<{ success: boolean; data: EmailTemplate }>(`/email-templates/${id}`);
        return response.data.data;
    }

    async createTemplate(data: Omit<EmailTemplate, '_id' | 'id'>) {
        const response = await api.post<{ success: boolean; data: EmailTemplate }>('/email-templates', data);
        return response.data.data;
    }

    async updateTemplate(id: string, data: Partial<EmailTemplate>) {
        const response = await api.put<{ success: boolean; data: EmailTemplate }>(`/email-templates/${id}`, data);
        return response.data.data;
    }

    async deleteTemplate(id: string) {
        await api.delete(`/email-templates/${id}`);
    }

    async getVariables(params?: { type?: string }) {
        const response = await api.get<{ success: boolean; data: { name: string; value: string }[] }>('/email-templates/variables', { params });
        return response.data.data;
    }

    async sendTestEmail(email: string, subject: string, content: string) {
        const response = await api.post<{ success: boolean; message: string }>('/email-templates/test-email', {
            email,
            subject,
            content,
        });
        return response.data;
    }

    async reorderTemplates(orderedIds: string[]) {
        const response = await api.put<{ success: boolean; message: string }>('/email-templates/reorder', { orderedIds });
        return response.data;
    }
}

export default new EmailTemplateService();
